export default "/_next/static/images/img5-c32edffc9e7fe242b265a9d6e7223390.png";